"use strict";

(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "@emotion/css", "react", "@emotion/core", "recompose/onlyUpdateForKeys", "./helpers"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("@emotion/css"), require("react"), require("@emotion/core"), require("recompose/onlyUpdateForKeys"), require("./helpers"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.css, global.react, global.core, global.onlyUpdateForKeys, global.helpers);
    global.undefined = mod.exports;
  }
})(void 0, function (exports, _css2, _react, _core, _onlyUpdateForKeys, _helpers) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _css3 = _interopRequireDefault(_css2);

  var _react2 = _interopRequireDefault(_react);

  var _onlyUpdateForKeys2 = _interopRequireDefault(_onlyUpdateForKeys);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  function _typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
      _typeof = function _typeof(obj) {
        return typeof obj;
      };
    } else {
      _typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      };
    }

    return _typeof(obj);
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
  }

  function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
      return call;
    }

    return _assertThisInitialized(self);
  }

  function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
      return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
  }

  function _assertThisInitialized(self) {
    if (self === void 0) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function");
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        writable: true,
        configurable: true
      }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
  }

  function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };

    return _setPrototypeOf(o, p);
  }

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  function _templateObject2() {
    var data = _taggedTemplateLiteral(["\n  0% {transform: scale(0.4)}\n  25% {translateY(", "px)}\n  50% {transform: scale(1.1)}\n  75% {transform: translateY(", "px)}\n  100% {transform: translateY(0) scale(0.75)}\n"]);

    _templateObject2 = function _templateObject2() {
      return data;
    };

    return data;
  }

  function _templateObject() {
    var data = _taggedTemplateLiteral(["\n  0% {transform: scale(1.1)}\n  25% {translateY(-", "px)}\n  50% {transform: scale(0.4)}\n  75% {transform: translateY(", "px)}\n  100% {transform: translateY(0) scale(1.0)}\n"]);

    _templateObject = function _templateObject() {
      return data;
    };

    return data;
  }

  function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
      raw = strings.slice(0);
    }

    return Object.freeze(Object.defineProperties(strings, {
      raw: {
        value: Object.freeze(raw)
      }
    }));
  }

  var riseAmount = 30;
  var even = (0, _core.keyframes)(_templateObject(), riseAmount, riseAmount);
  var odd = (0, _core.keyframes)(_templateObject2(), riseAmount, -riseAmount);

  var Loader = function (_React$Component) {
    _inherits(Loader, _React$Component);

    function Loader() {
      var _getPrototypeOf2;

      var _this;

      _classCallCheck(this, Loader);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Loader)).call.apply(_getPrototypeOf2, [this].concat(args)));

      _defineProperty(_assertThisInitialized(_this), "style", function (i) {
        var _this$props = _this.props,
            color = _this$props.color,
            size = _this$props.size,
            sizeUnit = _this$props.sizeUnit,
            margin = _this$props.margin;
        return (0, _core.css)("background-color:", color, ";width:", "".concat(size).concat(sizeUnit), ";height:", "".concat(size).concat(sizeUnit), ";margin:", "".concat(margin), ";border-radius:100%;display:inline-block;animation:", i % 2 === 0 ? even : odd, " 1s 0s infinite cubic-bezier(0.15,0.46,0.9,0.6);animation-fill-mode:both;label:style;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9SaXNlTG9hZGVyLmpzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUE0QmMiLCJmaWxlIjoic3JjL1Jpc2VMb2FkZXIuanN4Iiwic291cmNlc0NvbnRlbnQiOlsiLyoqIEBqc3gganN4ICovXG5pbXBvcnQgUmVhY3QgZnJvbSBcInJlYWN0XCI7XG5pbXBvcnQgeyBrZXlmcmFtZXMsIGNzcywganN4IH0gZnJvbSBcIkBlbW90aW9uL2NvcmVcIjtcbmltcG9ydCBvbmx5VXBkYXRlRm9yS2V5cyBmcm9tIFwicmVjb21wb3NlL29ubHlVcGRhdGVGb3JLZXlzXCI7XG5pbXBvcnQgeyBzaXplTWFyZ2luUHJvcHMsIHNpemVNYXJnaW5EZWZhdWx0cywgc2l6ZU1hcmdpbktleXMgfSBmcm9tIFwiLi9oZWxwZXJzXCI7XG5cbmNvbnN0IHJpc2VBbW91bnQgPSAzMDtcblxuY29uc3QgZXZlbiA9IGtleWZyYW1lc2BcbiAgMCUge3RyYW5zZm9ybTogc2NhbGUoMS4xKX1cbiAgMjUlIHt0cmFuc2xhdGVZKC0ke3Jpc2VBbW91bnR9cHgpfVxuICA1MCUge3RyYW5zZm9ybTogc2NhbGUoMC40KX1cbiAgNzUlIHt0cmFuc2Zvcm06IHRyYW5zbGF0ZVkoJHtyaXNlQW1vdW50fXB4KX1cbiAgMTAwJSB7dHJhbnNmb3JtOiB0cmFuc2xhdGVZKDApIHNjYWxlKDEuMCl9XG5gO1xuXG5jb25zdCBvZGQgPSBrZXlmcmFtZXNgXG4gIDAlIHt0cmFuc2Zvcm06IHNjYWxlKDAuNCl9XG4gIDI1JSB7dHJhbnNsYXRlWSgke3Jpc2VBbW91bnR9cHgpfVxuICA1MCUge3RyYW5zZm9ybTogc2NhbGUoMS4xKX1cbiAgNzUlIHt0cmFuc2Zvcm06IHRyYW5zbGF0ZVkoJHstcmlzZUFtb3VudH1weCl9XG4gIDEwMCUge3RyYW5zZm9ybTogdHJhbnNsYXRlWSgwKSBzY2FsZSgwLjc1KX1cbmA7XG5cbmNsYXNzIExvYWRlciBleHRlbmRzIFJlYWN0LkNvbXBvbmVudCB7XG4gIHN0eWxlID0gKGkpID0+IHtcbiAgICBjb25zdCB7IGNvbG9yLCBzaXplLCBzaXplVW5pdCwgbWFyZ2luIH0gPSB0aGlzLnByb3BzO1xuXG4gICAgcmV0dXJuIGNzc2BcbiAgICAgIGJhY2tncm91bmQtY29sb3I6ICR7Y29sb3J9O1xuICAgICAgd2lkdGg6ICR7YCR7c2l6ZX0ke3NpemVVbml0fWB9O1xuICAgICAgaGVpZ2h0OiAke2Ake3NpemV9JHtzaXplVW5pdH1gfTtcbiAgICAgIG1hcmdpbjogJHtgJHttYXJnaW59YH07XG4gICAgICBib3JkZXItcmFkaXVzOiAxMDAlO1xuICAgICAgZGlzcGxheTogaW5saW5lLWJsb2NrO1xuICAgICAgYW5pbWF0aW9uOiAke2kgJSAyID09PSAwID8gZXZlbiA6IG9kZH0gMXMgMHMgaW5maW5pdGUgY3ViaWMtYmV6aWVyKDAuMTUsIDAuNDYsIDAuOSwgMC42KTtcbiAgICAgIGFuaW1hdGlvbi1maWxsLW1vZGU6IGJvdGg7XG4gICAgYDtcbiAgfTtcblxuICByZW5kZXIoKSB7XG4gICAgY29uc3QgeyBsb2FkaW5nLCBjc3MgfSA9IHRoaXMucHJvcHM7XG5cbiAgICByZXR1cm4gbG9hZGluZyA/IChcbiAgICAgIDxkaXYgY3NzPXtbY3NzXX0+XG4gICAgICAgIDxkaXYgY3NzPXt0aGlzLnN0eWxlKDEpfSAvPlxuICAgICAgICA8ZGl2IGNzcz17dGhpcy5zdHlsZSgyKX0gLz5cbiAgICAgICAgPGRpdiBjc3M9e3RoaXMuc3R5bGUoMyl9IC8+XG4gICAgICAgIDxkaXYgY3NzPXt0aGlzLnN0eWxlKDQpfSAvPlxuICAgICAgICA8ZGl2IGNzcz17dGhpcy5zdHlsZSg1KX0gLz5cbiAgICAgIDwvZGl2PlxuICAgICkgOiBudWxsO1xuICB9XG59XG5cbkxvYWRlci5wcm9wVHlwZXMgPSBzaXplTWFyZ2luUHJvcHM7XG5cbkxvYWRlci5kZWZhdWx0UHJvcHMgPSBzaXplTWFyZ2luRGVmYXVsdHMoMTUpO1xuXG5jb25zdCBDb21wb25lbnQgPSBvbmx5VXBkYXRlRm9yS2V5cyhzaXplTWFyZ2luS2V5cykoTG9hZGVyKTtcbkNvbXBvbmVudC5kZWZhdWx0UHJvcHMgPSBMb2FkZXIuZGVmYXVsdFByb3BzO1xuZXhwb3J0IGRlZmF1bHQgQ29tcG9uZW50O1xuIl19 */"));
      });

      return _this;
    }

    _createClass(Loader, [{
      key: "render",
      value: function render() {
        var _this$props2 = this.props,
            loading = _this$props2.loading,
            css = _this$props2.css;
        return loading ? (0, _core.jsx)("div", {
          css: (0, _css3["default"])([css], "label:Loader;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"))
        }, (0, _core.jsx)("div", {
          css: this.style(1)
        }), (0, _core.jsx)("div", {
          css: this.style(2)
        }), (0, _core.jsx)("div", {
          css: this.style(3)
        }), (0, _core.jsx)("div", {
          css: this.style(4)
        }), (0, _core.jsx)("div", {
          css: this.style(5)
        })) : null;
      }
    }]);

    return Loader;
  }(_react2["default"].Component);

  Loader.propTypes = _helpers.sizeMarginProps;
  Loader.defaultProps = (0, _helpers.sizeMarginDefaults)(15);
  var Component = (0, _onlyUpdateForKeys2["default"])(_helpers.sizeMarginKeys)(Loader);
  Component.defaultProps = Loader.defaultProps;
  exports["default"] = Component;
});